import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ReferralList from '../ChatApp/Referals';
import ReferralLinkButton from '../Register/referalLinkButton';
import './Profile.css'; // Импорт стилей
import { useDispatch, useSelector } from 'react-redux';
import { selectIsBindPay, selectUserEmail, selectUserId, setIsBindPay } from '../Login/loginSlice';
import profilApi from '../../api/profilApi'; // Импорт API для получения userdata
import authApi from '../../api/authApi';
import RegistryManager from './RegistryManager';
import { Camera, Settings, X } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';
import { IoMdArrowBack } from "react-icons/io";
const Profile = () => {
    const [balance, setBalance] = useState(0); // Статичный баланс для примера
    const [hasPaymentOfOneRub, setHasPaymentOfOneRub] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [auth, setAuth] = useState(false);
    const [subscriptionInfo, setSubscriptionInfo] = useState('');
    const [paymentType, setPaymentType] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const userEmail = useSelector(selectUserEmail);
    const isBindPay = useSelector(selectIsBindPay);



    const [selectedImg, setSelectedImg] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [showReferals, setShowReferals] = useState(false);
    const [cardNumber, setCardNumber] = useState('');

    const fetchUserData = async () => {
        dispatch(setIsBindPay('wait'))
        try {
            // Получаем данные пользователя
            const response = await profilApi.fetchUserData(userEmail);
            //console.log('fetchUserData', response.data)
            // Устанавливаем данные о балансе и привязке карты
            if (response.data) {
                setBalance(response.data.balance ? response.data.balance.q : 0); // Извлекаем баланс
                // setHasPaymentOfOneRub(response.data.hasPaymentOfOneRub); // Проверка привязки карты
                // dispatch(setIsBindPay(response.data.hasPaymentOfOneRub))
                if (response.data.profileImage) {
                    setSelectedImg(response.data.profileImage.profilePic);
                    localStorage.setItem("profilePic", response.data.profileImage.profilePic);
                }
                const { subscriptionType, subscriptionEndDate, rebill, card_number } = response.data;

                const subscriptionEnd = new Date(subscriptionEndDate);
                const now = new Date();

                const isExpired = now > subscriptionEnd;
                dispatch(setIsBindPay(rebill !== ''))
                if (rebill !== '' && card_number) setCardNumber(card_number)
                if (subscriptionType) {
                    if(isExpired){
                        setSubscriptionInfo(`Срок подписки ${subscriptionType} истек`);
                    }else{
                        setSubscriptionInfo(`Подписка: ${subscriptionType}, до ${subscriptionEndDate}`);
                    }
                } else {
                    setSubscriptionInfo(""); // Если подписки нет, обнуляем текст
                }
            }
        } catch (error) {
            console.error('Ошибка при получении данных пользователя', error);
        }
    };

    const handleCircleClick = () => {
        setShowReferals(!showReferals);
    };

    const closePopup = () => {
        setShowReferals(false);
    };

    const handleSettingsClick = () => {
        setShowPopup(!showPopup);
    };

    const handleBuySubscription = () => {
        navigate('/subscription', { state: { paymentType: 'subscription' } })
    };
    const handleAddCard = () => {
        navigate('/subscription', { state: { paymentType: 'addcard' } })
    }



    const handleImageUpload = async (e) => {
        //console.log('handleImageUpload')
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append("profilePic", file);
        formData.append("email", userEmail); // Отправляем email, чтобы найти пользователя в БД

        try {
            //console.log('handleImageUpload start')
            const response = await profilApi.updateProfile(formData);
            //console.log('handleImageUpload response', response.data)
            if (response.data.success) {
                const imageUrl = response.data.profilePic;
                setSelectedImg(imageUrl); // Обновляем изображение
                localStorage.setItem("profilePic", imageUrl); // Сохраняем путь локально
                fetchUserData();
            }
        } catch (error) {
            console.error("Ошибка загрузки изображения:", error);
        }
    };




    const checkAuth = async () => {
        const token = localStorage.getItem('authToken');
        const expirationTime = localStorage.getItem('tokenExpiration');
        if (token && expirationTime && Date.now() < expirationTime) {
            try {
                const res = await authApi.checkAuth();
                if (res.data.status === 'success') {
                    setAuth(true);
                    return;
                }
            } catch (error) {
                console.error('error while authorization', error)
            } finally {
                // setLoading(false);
            }
        }

        setAuth(false);
        localStorage.removeItem('authToken');
        localStorage.removeItem('tokenExpiration');
        navigate('/login')
        // setMessage('Срок действия вашей авторизации истёк. Пожалуйста, войдите снова.');
    };

    const handleUnbinding = async () => {
        setShowPopup(false)
        setShowModal(true);
    }

    const clickUnbinding = async () => {
        try {
            setIsLoading(true);
            const res = await profilApi.unbindUser(userEmail);
            if (res.data.result === 'success') {
                dispatch(setIsBindPay(false));
                setHasPaymentOfOneRub(false);
                setShowSuccessMessage(true);
                fetchUserData()
                setTimeout(() => {
                    setShowSuccessMessage(false);
                }, 3000);
            }
        } catch (error) {
            console.error('Ошибка при отвязке карты:', error);
            alert('Произошла ошибка при отвязке карты');
        } finally {
            setIsLoading(false);
            setShowModal(false);  // Закрываем модальное окно после выполнения
        }
    };

    useEffect(() => {
        if (!userEmail) navigate('/login')
        // checkAuth();
        const storedProfilePic = localStorage.getItem("profilePic");
        if (storedProfilePic) {
            setSelectedImg(storedProfilePic);
        }
    }, []);

    useEffect(() => {


        if (userEmail) {
            fetchUserData();
        }
    }, [userEmail]);

    return (
        <div className='main'>
            <button className="back-button" onClick={() => navigate('/chat')}>
                <IoMdArrowBack className="back-icon" />
            </button>
            <div className="profile-container">
                {/* <div className='user_email'>
                {userEmail}
            </div> */}
                <h1 className="profile-heading">Личный кабинет</h1>
                <div className='profile_info'>
                    <div className="avatar-wrapper">
                        <img
                            src={selectedImg || "/avatar.png"}
                            alt="Profile"
                            className="profile-image"
                        />
                        <label htmlFor="avatar-upload" className={`upload-label`}>
                            <Camera className="camera-icon" />
                            <input
                                type="file"
                                id="avatar-upload"
                                className="hidden-input"
                                accept="image/*"
                                onChange={handleImageUpload}
                            />
                        </label>
                    </div>
                    {/* <p className="upload-text">
                        {isUpdatingProfile ? "Uploading..." : "Click the camera icon to update your photo"}
                    </p> */}

                    <div className='user-info'>

                        <label>{userEmail}</label>
                        <div className='subscription'>
                            <label>Баланс</label>
                            <label className='balance_text'>{balance} баллов</label>
                        </div>
                        <div className='profile_row'>
                            <ReferralLinkButton />
                        </div>
                    </div>
                </div>

                <div className='profile_cntr_row'>
                    <div className='profile_cntr'>
                        <div className="card-header">
                            <span className="card-title">Карта</span>
                            <Settings className="settings-icon" onClick={handleSettingsClick} />

                            {/* Popup/Popover */}
                            {showPopup && (
                                <div className="popup-container" onClick={() => setShowPopup(false)}>
                                    <div className="popup" onClick={(e) => e.stopPropagation()}>
                                        <div className="popup-header">
                                            <span className="popup-title">Настройки карты</span>
                                            <X className="popup-close" onClick={() => setShowPopup(false)} />
                                        </div>

                                        <div className="popup-section">
                                            <div className="popup-actions">
                                                {isBindPay ? (
                                                    <button className="profile_button danger" onClick={handleUnbinding}>
                                                        Отвязать карту
                                                    </button>
                                                ) : (
                                                    <button className="profile_button" onClick={handleAddCard}>
                                                        Добавить карту
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                        </div>
                        {/* нужно вывести данные с бэка для номера карты */}
                        <div className="card-number">
                            {(isBindPay === 'wait') ?
                                <span>{cardNumber ? cardNumber : '...'}</span> :
                                (isBindPay) ?
                                    <span>{cardNumber ? cardNumber : 'Карта привязана'}</span> :
                                    <span onClick={handleSettingsClick}>
                                        Карта не привязана
                                    </span>
                            }
                        </div>


                        {!subscriptionInfo && (
                            <div className='card-number'>
                                <span onClick={handleBuySubscription}>
                                    Купить подписку
                                </span>
                            </div>
                        )}

                        <div className='profile_row'>
                            {subscriptionInfo && subscriptionInfo !== "" ? (
                                <div className="subscription-info">{subscriptionInfo}</div>
                            ) : (
                                <div className="subscription-info">
                                    <span>нет текущей подписки </span>
                                </div>
                            )}
                        </div>

                        {showModal && (
                            <div className="modal-overlay">
                                <div className="modal_content">
                                    <p>Вы уверены, что хотите отвязать карту?</p>
                                    <div className="modal-buttons">
                                        <button
                                            className="modal-button"
                                            onClick={() => setShowModal(false)}  // Закрываем модальное окно
                                        >
                                            Нет
                                        </button>
                                        <button
                                            className="modal-button"
                                            onClick={clickUnbinding}
                                            disabled={isLoading}
                                        >
                                            {isLoading ? 'Загрузка...' : 'Да'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                        {showSuccessMessage && (
                            <div className="success-message">
                                Карта успешно отвязана
                            </div>
                        )}


                    </div>

                    <div className='profile_cntr'>
                        <div className="card-header">
                            <span className="card-title">Рефералы</span>
                        </div>
                        <div className="card-number" onClick={handleCircleClick}>
                            <span>Ваш круг</span>
                        </div>
                        <div className="referral-info">
                            <span>За каждого приглашённого 500 баллов</span>
                        </div>

                        {showReferals && (
                            <div className="popup-overlay">
                                <div className="ref-container">
                                    <div className="popup-header">
                                        <span className="popup-title">Рефералы</span>
                                        <X className="close-icon" onClick={closePopup} />
                                    </div>
                                    <div className="popup-content">
                                        <ReferralList />
                                    </div>
                                </div>
                            </div>
                        )}
                        {/* </div> */}
                        {/* <div className="referrals-section">
                        <ReferralList />
                    </div>
                    <div>
                        <p><strong>После регистрации по этой ссылке вашего друга и получения им первого платного ответа на ваш счет в личном кабинете будет начислено 200 рублей</strong></p>
                    </div> */}
                    </div>
                </div>

                <RegistryManager />

            </div>
        </div>
    );
};

export default Profile;
